import { render, staticRenderFns } from "./input-trace.vue?vue&type=template&id=448d1a7c&scoped=true&"
var script = {}
import style0 from "./input-trace.vue?vue&type=style&index=0&id=448d1a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d1a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448d1a7c')) {
      api.createRecord('448d1a7c', component.options)
    } else {
      api.reload('448d1a7c', component.options)
    }
    module.hot.accept("./input-trace.vue?vue&type=template&id=448d1a7c&scoped=true&", function () {
      api.rerender('448d1a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/input-trace.vue"
export default component.exports